module.exports = __webpack_public_path__ + "static/img/yf_08.31a371d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yf/yf_08.jpg
// module id = y7wt
// module chunks = 1